var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04647 1.04586C1.24173 0.850599 1.55832 0.850599 1.75358 1.04586L5.99622 5.2885L10.2389 1.04586C10.4341 0.850599 10.7507 0.850599 10.946 1.04586C11.1412 1.24112 11.1412 1.55771 10.946 1.75297L6.70333 5.99561L10.946 10.2382C11.1412 10.4335 11.1412 10.7501 10.946 10.9454C10.7507 11.1406 10.4341 11.1406 10.2389 10.9454L5.99622 6.70271L1.75358 10.9454C1.55832 11.1406 1.24173 11.1406 1.04647 10.9454C0.851209 10.7501 0.851209 10.4335 1.04647 10.2382L5.28911 5.99561L1.04647 1.75297C0.851209 1.55771 0.851209 1.24112 1.04647 1.04586Z",
    fill: "#113601"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.d05e40e6b9bab61639c7bb85ab16140a.svg";
export { ForwardRef as ReactComponent };